<template lang="pug">
#NavBar
  .nav
    b-container
      img.logo(src="../../../public/Now-Logo.png")
      b-navbar.bar.sombra(variant="light" toggleable="md")
        b-navbar-toggle(target="nav_collapse")
        b-collapse(is-nav id="nav_collapse")
          b-navbar-nav
            .link
              .material-icons-outlined {{ user.role === 'delivery' ? 'local_shipping' : 'home' }}
              b-nav-item(:to="'/'" exact) {{ user.role === 'delivery' ? 'Envíos' : 'Inicio' }}
            .link(v-if="user.role==='store'")
              .material-icons-outlined local_shipping
              b-nav-item(:to="'/envios'") Envíos
            .link(v-if="user.role==='admin'")
              .material-icons-outlined admin_panel_settings
              b-nav-item(:to="'/usuarios'") Adm.Usuarios
            .link(v-if="user.role==='admin'")
              .material-icons-outlined store
              b-nav-item(:to="'/tiendas'") Tiendas
            .link(v-if="user.role==='store'")
              .material-icons-outlined schedule
              b-nav-item(:to="'/crear-retiro'") Programar Retiro
            .link(v-if="user.role==='store'")
              .material-icons-outlined settings
              b-nav-item(:to="'/configuracion-tienda'") Configuración
            .link(v-if="['admin'].includes(user.role)")
              .material-icons-outlined local_shipping
              b-nav-item(:to="'/envios'") Envíos
            .link(v-if="['admin'].includes(user.role)")
              .material-icons-outlined pending_actions
              b-nav-item(:to="'/retiros'") Retiros
            .link(v-if="['admin'].includes(user.role)")
              .material-icons-outlined report
              b-nav-item(:to="'/excepciones'") Excepciones
            .link(
              v-if="checkPermissions([permissions.STORE_SHOPIFY_INTEGRATION, permissions.STORE_API_ACCESS])"
            )
              .material-icons-outlined integration_instructions
              b-nav-item(:to="'/integraciones'") Integraciones
            //- Link a vista de escaneo (solo admin y delivery)
            .link(v-if="canScan")
              .material-icons-outlined qr_code_scanner
              b-nav-item(:to="'/escaner-en-tienda'") Escanear QR
          b-navbar-nav.ml-auto
            a.mt-1.mr-2(href="https://www.instagram.com/envios.now/" target="_blank")
              img(src="../../../public/img/instagram.png" style="height: 25px")
            .link
              .material-icons person
              b-nav-item-dropdown.link(right)
                template(v-slot:button-content)
                  span {{fullName}}
                b-dropdown-item(@click="logout")
                  span.sesion-item  Cerrar Sesión
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import permissions from '../../shared/authUtils'

export default {
  data() {
    return {
      fullName: {}
    }
  },
  created() {
    this.getUser()
  },
  methods: {
    ...mapActions(['logout']),
    getUser() {
      const user = JSON.parse(localStorage.getItem('user')).user
      this.fullName = `${user.name} ${user.lastName}`
    },
    checkRole(roles) {
      return roles.includes(this.user.role)
    }
  },
  computed: {
    ...mapGetters(['user', 'checkPermissions']),
    permissions() {
      return permissions.permissions
    },
    canScan() {
      return this.user && (this.user.role === 'admin' || this.user.role === 'delivery')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../src/styles/colors.scss';

#NavBar {
  background: linear-gradient(to right, hsla(0, 0%, 58%, 1), hsla(0, 0%, 40%, 1));
  height: 110px;
}

.bar {
  border-radius: 10px;
  margin-top: -9px;
  font-family: 'Source Sans Pro Semi Bold', sans-serif;
  font-weight: 700;
  font-size: 15px;
  z-index: 2;
}

.logo {
  width: 80px;
  margin: 6px 0px 0px 0px;
}

.link {
  color: var(--light-primary);
  align-items: center;
  display: flex;
  margin-right: 20px;
}
</style>